import React, { useCallback, useEffect, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { Container } from 'reactstrap';

// import AddWhiteIcon from 'assets/images/add-white.svg';
import Breadcrumb from 'components/App/Breadcrumb';
// import Button from 'components/App/Button';
import Meta from 'components/App/Meta';
import { LOCATIONS } from 'constants/index';
import cn from 'utils/classnames';
import { getParamsFormObject } from 'utils';

import ConversionPolicy from './ConversionPolicy';
import HistoryCoin from './HistoryCoin';
import styles from './ManagerCoin.module.scss';

const TAB = {
  POLICY: 'policy',
  HISTORY: 'history',
};

const NAV_TABS = [
  { value: TAB.POLICY, title: 'Chính sách quy đổi' },
  { value: TAB.HISTORY, title: 'Lịch sử xu' },
];

const breadcrumbList = [
  {
    name: 'Quản lý xu',
    isActive: true,
    link: LOCATIONS.MANAGER_COIN,
  },
];

const isValidTab = (tab) => NAV_TABS.some((item) => item.value === tab);

function ManagerCoin() {
  const history = useHistory();

  const activeTab = useMemo(() => {
    const params = new URLSearchParams(history.location.search);
    const tab = params.get('tab');

    return isValidTab(tab) ? tab : TAB.POLICY;
  }, [history.location.search]);

  useEffect(() => {
    const params = new URLSearchParams(history.location.search);
    const tab = params.get('tab');

    if (!isValidTab(tab)) {
      history.replace({
        pathname: LOCATIONS.MANAGER_COIN,
        search: getParamsFormObject({ tab: TAB.POLICY }),
      });
    }
  }, [history, history.location.search]);

  const onSelectTab = useCallback((tab) => () => {
    history.push({
      pathname: LOCATIONS.MANAGER_COIN,
      search: getParamsFormObject({ tab }),
    });
  }, [history]);

  return (
    <div className={cn('page-content', styles.Page)}>
      <Meta name="Quản lý xu" />

      <Container fluid>
        <Breadcrumb pageTitle="QUẢN LÝ XU" breadcrumbList={breadcrumbList} />

        <div className="Section">
          <div className="Tab__Header__Container">
            <div className="Tab__Header">
              <nav className="Tab__Header__Nav" aria-label="Quản lý xu">
                {NAV_TABS.map((tab) => (
                  <div key={tab.value} className="Tab__Header__Tab">
                    <button
                      type="button"
                      onClick={onSelectTab(tab.value)}
                      className={cn(
                        'Tab__Header__Tab__Item',
                        activeTab === tab.value && 'Active',
                      )}
                    >
                      {tab.title}
                    </button>
                  </div>
                ))}
              </nav>
            </div>

            {/* <Button
              type="button"
              classes="Tab__Header__Button"
              onClick={onSendBcoin}
            >
              <img src={AddWhiteIcon} alt="" />
              <span className="Tab__Header__Button__Text">Gửi Bcoin</span>
            </Button> */}
          </div>
        </div>

        {activeTab === TAB.POLICY && <ConversionPolicy />}
        {activeTab === TAB.HISTORY && <HistoryCoin />}
      </Container>
    </div>
  );
}

export default ManagerCoin;
